/**
 * get style of element
 *
 * @param {HTMLElement} el Выбранный элемент
 *
 * @param {string} styleProp название css свойства
 *
 * @return {string}
 *
 * @example getNodeStyle('.el', height) => '55px';
 */
import { objectHasKey } from '@utils';

export const getNodeStyle = (el: HTMLElement, styleProp: string) => {
	let style: string | CSSRule;

	if (window && window.getComputedStyle) {
		style = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
	} else if (el && objectHasKey(el.style, styleProp)) {
		style = el.style[styleProp] as string;
	}

	return style as string;
};
